import { ClassNames } from '../../../../utils/misc';

export const ProgressBarContainerClassNames = ClassNames.component('progress-bar-container');
